
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-nas",
      function () {
        return require("private-next-pages/o-nas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-nas"])
      });
    }
  